export enum InvoiceType {
    Invoice = "Invoice",
    CreditNote = "CreditNote"
}
